export const WORKSHOP_NOTE = (
    <div className="note-wrapper">
        <p>Når du har valgt et af værkstederne herover, udveksler vi følgende oplysninger med værkstedet:</p>
        <p>
            dine kontaktoplysninger, oplysninger om din bil og hvor på bilen der er skader, herunder de fotos du har
            indsendt.
        </p>
    </div>
);

export const NO_SHOP_FOUND = (
    <p>
        Vi kunne desværre ikke finde noget værksted i dit område. Tjek, at postnummeret er korrekt, eller prøv at søge i
        et andet område. Du kan også fortsætte anmeldelsen uden at vælge et værksted.
    </p>
);

export const WORKSHOPS_SERVICE_UNAVAILABLE = (
    <p>Det er desværre ikke muligt at vise dig nogle værksteder. Fortsæt anmeldelsen eller prøv igen senere.</p>
);

export const CARBUCKS_SERVICE_UNAVAILABLE = (
    <p>
        Det er desværre ikke muligt at booke en tid lige nu. Prøv igen eller fortsæt anmeldelsen uden at booke en tid.
    </p>
);
